module.exports = __webpack_public_path__ + "assets/devices/GB-502-PG2-ff0f8cb91463c0d2642e823a841d81fd.svg";